import { useEffect } from 'react';

interface UseIndividualCalendarEffectsProps {
  validatePeriodSearchParamsHandler(): void;
}

export const useIndividualCalendarEffects = ({
  validatePeriodSearchParamsHandler,
}: UseIndividualCalendarEffectsProps) => {
  useEffect(() => {
    validatePeriodSearchParamsHandler();
  }, [validatePeriodSearchParamsHandler]);
};
